import React from 'react';

import * as S from './styled';

import type {
  IconProps,
} from './styled';

/**
 * Icon
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Icon = ({
  type,
  size,
  color,
  transform,
}: IconProps) => (
  <S.StyledIcoin
    size={size}
    color={color}
    transform={transform}
    className={`${type}`}
  />
);

Icon.defaultProps = {
  size: 'inherit',
  color: 'inherit',
  transform: '',
};

export default Icon;
